var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "elevation-2",
        class: { dragging: _vm.is_dragging },
        attrs: { id: "drop-zone" },
        on: { dragover: _vm.dragover, dragleave: _vm.dragleave, drop: _vm.drop }
      },
      [
        _c("input", {
          ref: "ticket_form_fileinput",
          staticClass: "hidden-input",
          attrs: {
            type: "file",
            multiple: "",
            name: "ticket_form_fileinput",
            id: "ticket_form_fileinput"
          },
          on: {
            change: function($event) {
              return _vm.onChange($event.target.files)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "file-label",
            attrs: { for: "ticket_form_fileinput" }
          },
          [
            _c(
              "v-layout",
              {
                attrs: {
                  row: "",
                  wrap: "",
                  "align-center": "",
                  "justify-center": ""
                }
              },
              [
                _c(
                  "v-flex",
                  { attrs: { shrink: "" } },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-3",
                        attrs: { size: 80, color: "primary" }
                      },
                      [_vm._v("\n\t\t\t\t\tcloud_upload\n\t\t\t\t")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticClass: "subheading", attrs: { shrink: "" } },
                  [
                    _vm._v(
                      "\n\t\t\t\t\tDéposez vos images ici ou collez une capture via\n\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { shrink: "" } },
                  [
                    _c(
                      "v-chip",
                      {
                        staticClass: "elevation-4 ml-3",
                        attrs: { label: "", color: "background" }
                      },
                      [_vm._v("\n\t\t\t\t\t\tCTRL + V\n\t\t\t\t\t")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        Object.keys(_vm.items).length
          ? _c(
              "v-container",
              { staticClass: "pa-2", attrs: { "grid-list-md": "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  _vm._l(_vm.items, function(item, filename) {
                    return _c(
                      "v-flex",
                      { key: filename, attrs: { shrink: "" } },
                      [
                        _c("Attachment", {
                          attrs: { item: item },
                          on: {
                            delete: function($event) {
                              return _vm.$emit("delete", filename)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-645b0111", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645b0111","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/about/ticket_form_attachment.vue
// module id = null
// module chunks = 